class Menu {

    constructor() {
        this.mobileButton         = document.querySelector('#navOpener');
        this.deviceBreakpoint     = 1200;
    }

    setDevice() {
        document.body.classList.remove('js-navMobile', 'js-navDesktop', 'js-navOpened');

        if (this.deviceBreakpoint >= window.innerWidth) {
            document.body.classList.add('js-navMobile');
        } else {
            document.body.classList.add('js-navDesktop');
        }
    }


    // prevent multiple resize triggers
    listener_device() {
        let ok_to_resize = true;
        window.addEventListener('resize', () => {
            if (ok_to_resize){    
                this.setDevice();
                ok_to_resize = false;
                setTimeout( () => {
                    ok_to_resize = true;
                }, 100);
            }
        });
    }

    listener_toggleMobileNav() {
        this.mobileButton.addEventListener('click', () => {

            const navOpened      = document.body.classList.contains('js-navOpened');

            if (navOpened) {
                document.body.classList.remove('js-navOpened');
            } else {
                document.body.classList.add('js-navOpened');
            }
        })
    }

    init(){
        this.setDevice();
        this.listener_device();
        this.listener_toggleMobileNav();
    }
}


export const initMenu = () => {
    
    const newMenu = new Menu();
    newMenu.init();
}
